export const MOMSSATS_TOLERANS_DEFAULT_VALUE = 2;
export const MOMS_MOMSSATS_DEFAULT_VALUE = 0.25;
export const MAX_NUMBER_OF_KONTODELAR = 10;
